import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useSiteContext } from "../../../state/SiteContext";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";
import { useFilterContext } from "../../../state/FilterContext";
import { Metadata } from "../../../shared/models/metadata.model";
import { services } from "../../../globals";
import { mapMetadataToItem } from "../../../shared/utils/source-item.utils";

interface BaselineQueryProps {
    contentType?: string,
}

/***
 * Array source that returns the result of a search query where the validity is
 * specified by the diffBase property in the filter state.
 */
export const BaselineQuery = React.memo(function BaselineQuery({ contentType }: BaselineQueryProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();
    const { filterState } = useFilterContext();

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            const request: MetadataRequest = { ...filterState, validity: filterState.baseline };
            contentType && (request.contentType = contentType);
            let searchlist: Array<Metadata> = [];
            if (siteState.site?.name) {
                searchlist = await services.search.search(
                    siteState.site.name,
                    request,
                );
                const result = searchlist.map((hit, ix) => {
                    return { ...mapMetadataToItem(hit), position: ix + 1, state: { validity: filterState.baseline } };
                });
                if (isMounted) {
                    setArray(result);
                }
            }
        };
        fetchData();
        return () => { isMounted = false; };
    }, [siteState, filterState, contentType, setArray]);

    return <></>;
});